import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from './../SvgIcon';

const UpdateIcon = (props) => (
  <SvgIcon {...props}>
    <polygon points="11,6.415 11,16.001 13,16.001 13,6.415 16.293,9.708 17.707,8.294 12,2.587 6.293,8.294 
      7.707,9.708     "/>
    <path d="M18,18.001v2H6v-2H4v2c0,1.102,0.897,2,2,2h12c1.104,0,2-0.898,2-2v-2H18z"/>
  </SvgIcon>
)

UpdateIcon.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  viewBox: PropTypes.string.isRequired,
};

UpdateIcon.defaultProps = {
  width: 20,
  height: 14,
  viewBox: '0 0 24 22',
};

export default UpdateIcon;